/**
 * Equalize element heights
 * usable e.g. then need to set equal height titles in a container
 */
function setHeight(el, val) {
  if (typeof val === "function") {
    val = val();
  }
  if (typeof val === "string") {
    el.style.height = val;
  } else {
    el.style.height = val + "px";
  }
}

const equalheight = function(container) {
  let currentTallest = 0,
    currentRowStart = 0,
    rowDivs = [],
    $el,
    topPosition = 0;

  Array.from(document.querySelectorAll(container)).forEach((el, i) => {
    el.style.height = "auto";
    topPosition = el.offsetTop;
    if (currentRowStart !== topPosition) {
      for (let currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        setHeight(rowDivs[currentDiv], currentTallest);
      }
      rowDivs.length = 0;
      currentRowStart = topPosition;
      currentTallest = parseFloat(getComputedStyle(el, null).height.replace("px", ""));
      rowDivs.push(el);
    } else {
      rowDivs.push(el);
      currentTallest = (currentTallest < parseFloat(getComputedStyle(el, null).height.replace("px", ""))) ? (parseFloat(getComputedStyle(el, null).height.replace("px", ""))) : (currentTallest);
    }
    for (let currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      setHeight(rowDivs[currentDiv], currentTallest);
    }
  });
};